import { PageHero } from "@/components/site/PageHero";
import { StudentExperience } from "@/components/home/StudentExperience";
import { ApplicationProcess } from "@/components/site/ApplicationProcess";
import { ParentSection } from "@/components/home/ParentSection";
import { DirectEntry } from "@/components/home/DirectEntry";
import { Eligibility } from "@/components/home/Eligibility";
import { IMAGES } from "@/data/content";
import { useSEO } from "@/hooks/useSite";

export default function StudentInfo() {
  useSEO({
    title: "Student Information | IAUE School of Basic Studies",
    description: "Student and parent information for the School of Basic Studies, IAUE — the student experience, application process, eligibility and Direct Entry pathway.",
  });
  return (
    <>
      <PageHero overline="Student Information" title="Everything Students & Parents Should Know"
        subtitle="From the student experience to the application process — clear guidance for your journey."
        crumb="Student Info" image={IMAGES.library} />
      <StudentExperience />
      <ApplicationProcess light />
      <Eligibility />
      <ParentSection />
      <DirectEntry />
    </>
  );
}
